import OrderFlowSalonPage from "./OrderFlowSalonPage";

export {OrderFlowSalonPage}
export default OrderFlowSalonPage
